import { render, staticRenderFns } from "./TableFiles.vue?vue&type=template&id=2a33d427&scoped=true&"
import script from "./TableFiles.vue?vue&type=script&lang=js&"
export * from "./TableFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a33d427",
  null
  
)

export default component.exports